import differenceInDays from 'date-fns/differenceInDays';
import differenceInMonths from 'date-fns/differenceInMonths';
import { formatResponseError } from '../utils/api';
import { h } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export const toastMixin = {
    methods: {
        hideToast(id) {
            this.$bvToast.hide(id);
        },
        successToast({ text, title = 'Success!' }) {
            // const h = this.$createElement;
            const id = `toast-${title}-${Math.random()}`;
            const vNodesMsg = h(
                'div',
                {
                    onClick: () => this.hideToast(id),
                    class: ['text-strong', 'mb-0', 'd-flex', 'align-items-center'],
                },
                [
                    h(FontAwesomeIcon, {
                        icon: ['fas', 'check'],
                        style: {
                            width: '19px',
                            height: '19px',
                            color: '#fff',
                        },
                    }),
                    h(
                        'span',
                        {
                            class: ['ml-2', 'd-block', 'text-white'],
                        },
                        [h('strong', `${text}`)]
                    ),
                ]
            );
            const vNodesTitle = h(
                'div',
                {
                    onClick: () => this.hideToast(id),
                    class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2'],
                },
                [h('strong', { class: 'mr-2' }, title)]
            );
            this.$bvToast.toast([vNodesMsg], {
                id,
                title: [vNodesTitle],
                noCloseButton: true,
                headerClass: 'toast-success-custom-header',
                toastClass: 'toast-success-custom-wrapper',
            });
        },
        errorToast({ text, title = 'Error!', autoHideDelay = 5000 }) {
            // const h = this.$createElement;
            const id = `toast-${title}-${Math.random()}`;

            const vNodesMsg = h(
                'div',
                {
                    onClick: () => this.hideToast(id),
                    class: ['text-strong', 'mb-0', 'd-flex', 'align-items-center'],
                },
                [
                    h(FontAwesomeIcon, {
                        icon: ['fas', 'circle-exclamation'],
                        style: {
                            width: '19px',
                            height: '19px',
                            color: '#fff',
                        },
                    }),
                    h(
                        'span',
                        {
                            class: ['ml-2', 'd-block', 'text-white'],
                        },
                        [h('strong', `${text}`)]
                    ),
                ]
            );
            const vNodesTitle = h(
                'div',
                {
                    onClick: () => this.hideToast(id),
                    class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2'],
                },
                [h('strong', { class: 'mr-2' }, title)]
            );
            this.$bvToast.toast([vNodesMsg], {
                id,
                title: [vNodesTitle],
                noCloseButton: true,
                toastClass: 'toast-error-custom-wrapper',
                headerClass: 'toast-custom-error-header',
                autoHideDelay,
            });
        },
        warningToast({ text, title = 'Warning!' }) {
            // const h = this.$createElement;
            const id = `toast-${title}-${Math.random()}`;
            const vNodesMsg = h(
                'div',
                {
                    onClick: () => this.hideToast(id),
                    class: ['text-strong', 'mb-0', 'd-flex', 'align-items-center'],
                },
                [
                    h(FontAwesomeIcon, {
                        icon: ['fas', 'exclamation-triangle'],
                        style: {
                            width: '19px',
                            height: '19px',
                            color: '#fff',
                        },
                    }),
                    h(
                        'span',
                        {
                            class: ['ml-2', 'd-block', 'text-white'],
                        },
                        [h('strong', `${text}`)]
                    ),
                ]
            );
            const vNodesTitle = h(
                'div',
                {
                    onClick: () => this.hideToast(id),
                    class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2'],
                },
                [h('strong', { class: 'mr-2' }, title)]
            );
            this.$bvToast.toast([vNodesMsg], {
                id,
                title: [vNodesTitle],
                noCloseButton: true,
                toastClass: 'toast-warning-custom-wrapper',
                headerClass: 'toast-custom-warning-header',
            });
        },
        infoToast({ text, title = 'Information' }) {
            // const h = this.$createElement;
            const id = `toast-${title}-${Math.random()}`;
            const vNodesMsg = h(
                'div',
                {
                    onClick: () => this.hideToast(id),
                    class: ['text-strong', 'mb-0', 'd-flex', 'align-items-center'],
                },
                [
                    h(FontAwesomeIcon, {
                        icon: ['fas', 'circle-info'],
                        style: {
                            width: '19px',
                            height: '19px',
                            color: '#fff',
                        },
                    }),
                    h(
                        'span',
                        {
                            class: ['ml-2', 'd-block', 'text-white'],
                        },
                        [h('strong', `${text}`)]
                    ),
                ]
            );
            const vNodesTitle = h(
                'div',
                {
                    onClick: () => this.hideToast(id),
                    class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2'],
                },
                [h('strong', { class: 'mr-2' }, title)]
            );
            this.$bvToast.toast([vNodesMsg], {
                id,
                title: [vNodesTitle],
                noCloseButton: true,
                headerClass: 'toast-info-custom-header',
                toastClass: 'toast-info-custom-wrapper',
            });
        },
        generatingExcelReportSuccessToast() {
            this.successToast({ text: 'Generating Excel Report...' });
        },
        generatingPdfReportSuccessToast() {
            this.successToast({ text: 'Generating PDF Report...' });
        },
        limitReportPeriodErrorToast({ currentStartDate, currentEndDate } = {}) {
            let text;
            if (!currentStartDate || !currentEndDate) {
                text = `Please, limit the reporting period for this report and try again.`;
            } else {
                const months = differenceInMonths(currentEndDate, currentStartDate);
                const days = differenceInDays(currentEndDate, currentStartDate);
                const period =
                    months > 12
                        ? 'one year or less'
                        : months > 6
                        ? 'half a year or less'
                        : months > 3
                        ? 'three months or less'
                        : months > 1
                        ? 'one month or less'
                        : days > 7
                        ? 'one week or less'
                        : 'one day';

                text = `Please, limit the reporting period to ${period} for this report and try again.`;
            }
            this.errorToast({ text, autoHideDelay: 8000 });
        },
        formattedErrorToast(e, message) {
            const { generic } = formatResponseError(e);
            this.errorToast({
                text: generic || message,
            });
        },
        infoActionToast({ text, title = 'Information', callback }) {
            // const h = this.$createElement;
            const id = `toast-${title}-${Math.random()}`;
            const vNodesMsg = h(
                'div',
                {
                    onClick: () => {
                        callback();
                        this.hideToast(id);
                    },
                    class: ['text-strong', 'mb-0', 'd-flex', 'align-items-center'],
                },
                [
                    h(FontAwesomeIcon, {
                        icon: ['fas', 'circle-info'],
                        style: {
                            width: '19px',
                            height: '19px',
                            color: '#fff',
                        },
                    }),
                    h(
                        'span',
                        {
                            class: ['ml-2', 'd-block', 'text-white'],
                        },
                        [h('strong', `${text}`)]
                    ),
                ]
            );
            const vNodesTitle = h(
                'div',
                {
                    onClick: () => {
                        callback();
                        this.hideToast(id);
                    },
                    class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2'],
                },
                [h('strong', { class: 'mr-2 text-white' }, title)]
            );

            this.$bvToast.toast([vNodesMsg], {
                id,
                title: [vNodesTitle],
                noCloseButton: false,
                headerClass: 'toast-info-custom-header',
                toastClass: 'toast-info-custom-wrapper',
            });
        },
    },
};
